import {
  getAllLprEventByLicenseAsync,
  getAllLprEventCountByLicenseAsync,
  getLprEventByIdAsync,
} from '../../index';
import { useMutation } from 'react-query';

export const useGetLprEventByIdAsync = () => useMutation(getLprEventByIdAsync);

export const useGetAllLprEventByLicenseAsync = () =>
  useMutation(getAllLprEventByLicenseAsync);

export const useGetAllLprEventByLicenseCountAsync = () =>
  useMutation(getAllLprEventCountByLicenseAsync);
